import React from 'react';
import ReactDom from 'react-dom/client';
import App from './components/App';
import {Provider} from 'react-redux';
import { persistor,store } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';

const root=ReactDom.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <App/>
        </PersistGate>
    </Provider>
)

